module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1400.12fbd1a4.svg";